/*
 * Created Date: 15-10-2021, 1:57:30 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2021 VNE E-COMMERCE, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { Checkbox, FormControlLabel, FormGroup, FormHelperText, FormLabel, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { Controller } from 'react-hook-form'

const CoreCheckboxGroup = props => {
	const { className, control, name, legendLabel, options, row, required, renderOption, disabled, ...restProps } =
		props

	return (
		<div className={className}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
					const handleChange = e => {
						onChange({
							...value,
							[e.target.name]: e.target.checked
						})
					}
					return (
						<>
							{legendLabel && (
								<FormLabel error={!!error} component="legend" required={required}>
									{legendLabel}
								</FormLabel>
							)}
							<FormGroup row={row} {...restProps}>
								{options.map((field, index) =>
									renderOption ? (
										renderOption(`${name}.${field.key}`, { ...field, disabled })
									) : (
										<FormControlLabel
											key={index}
											label={<Typography>{field?.label}</Typography>}
											control={
												<Checkbox
													name={field.key}
													checked={Boolean(value[field.key])}
													onChange={handleChange}
													// color="blue"
												/>
											}
										/>
									)
								)}
							</FormGroup>
							{error && error.message && <FormHelperText error={!!error}>{error.message}</FormHelperText>}
						</>
					)
				}}
			/>
		</div>
	)
}

CoreCheckboxGroup.defaultProps = {
	className: null,
	legendLabel: null,
	row: false,
	options: [],
	disabled: false
}

CoreCheckboxGroup.propTypes = {
	className: PropTypes.string,
	control: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	legendLabel: PropTypes.string,
	row: PropTypes.bool,
	required: PropTypes.bool,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			label: PropTypes.any.isRequired,
			disabled: PropTypes.bool
		})
	).isRequired,
	renderOption: PropTypes.func,
	disabled: PropTypes.bool
}

export default React.memo(CoreCheckboxGroup)
